<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-blue-400 hover:text-blue-600" :href="route('category')">Localidad</inertia-link>
      <span class="text-blue-400 font-medium">/</span> Crear
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <span class="pr-6 pb-8 w-full" >Url:  {{ slug}}</span>
         <!-- <text-input v-model="form.url" :error="form.errors.url" class="pr-6 pb-8 w-full lg:w-1/2" label="Url" /> -->
          <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" />
         

          <!-- <text-area-input v-model="" :error="form.errors.texto" class="pr-6 pb-8 w-full lg:w-1/2" label="Texto" /> -->
          <text-area-input v-model="form.ubicacion" :error="form.errors.ubicacion" class="pr-6 pb-8 w-full lg:w-1/2" label="Ubicacion" />
          <text-input v-model="form.mapongo" :error="form.errors.mapongo" class="pr-6 pb-8 w-full lg:w-1/2" label="Mapa Coordenadas" />
           <vue-editor class="w-full" v-model="form.texto"  :editor-toolbar="customToolbar"  />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t mt-12 border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Localidad</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextAreaInput from '@/Shared/TextAreaInput'
import { VueEditor } from "vue2-editor";


export default {
  metaInfo: { title: 'Crear Publicidad' },
  components: {
    LoadingButton,
    SelectInput,
    VueEditor,
    TextInput,
    TextAreaInput
  },
  layout: Layout,
  remember: 'form',
  computed: {
    slug: function() {
      let slug = 'https://lapedrera.com.uy/localidad-'+this.sanitizeTitle(this.form.nombre);
      return slug;
    }
  },
  data() {
    return {
      customToolbar: [
      [{ header: [false, 2] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        // [
        //   { align: "" },
        //   { align: "center" },
        //   { align: "right" },
        //   { align: "justify" }
        // ],
        // ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link"],
        ["clean"] // remove formatting button,
      ],
      form: this.$inertia.form({
        url: null,
        nombre: null,
        texto: null,
        ubicacion: null,
        publicado: null,
        mapongo: null,
        
      }),
    }
  },
  methods: {
     sanitizeTitle: function(title) {
       if(!title) return ''
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd');
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '');
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '-');
      
      return slug;
    },
    store() {
      this.form.post(this.route('locations.store'))
    },
  },
}
</script>
